import React, { useState } from "react"
import { Flex, Box, useOutsideClick } from "@chakra-ui/react"
import ReactSlider from "react-slider"
import { colors } from "@app/theme/colors"
import Icon from "@components/Icon/Icon"

const FilterSlider: React.FC = (filter: any) => {
  const ref = React.useRef()
  const [isOpen, setIsOpen] = useState(false)
  
  const defaultValue = filter?.filterSliderProps?.reactSliderProps?.defaultValue || [0, 280];
  const initialValue = filter?.filterSliderProps?.value?.[1] !== 0 ? filter?.filterSliderProps?.value : defaultValue;
  
  // Initialize local state with valid numbers
  const [localValue, setLocalValue] = useState<[number, number]>([
    Number.isFinite(initialValue[0]) ? initialValue[0] : defaultValue[0],
    Number.isFinite(initialValue[1]) ? initialValue[1] : defaultValue[1]
  ]);

  // Update local state when props change
  React.useEffect(() => {
    if (filter?.filterSliderProps?.value) {
      const min = Number.isFinite(filter?.filterSliderProps?.value[0]) ? filter?.filterSliderProps?.value[0] : defaultValue[0];
      const max = Number.isFinite(filter?.filterSliderProps?.value[1]) && filter?.filterSliderProps?.value[1] !== 0 ? filter?.filterSliderProps?.value[1] : defaultValue[1];
      console.log(min, max);
      if (localValue[0] !== min || localValue[1] !== max) {
        setLocalValue([min, max]);
      }
    }
  }, [filter?.filterSliderProps?.value, defaultValue, localValue]);

  useOutsideClick({
    ref: ref,
    handler: () => setIsOpen(false),
  })

  return (
    <Flex position="relative" mr={1} ref={ref}>
      <Flex
        fontSize="15px"
        fontWeight={"medium"}
        alignItems={"center"}
        borderRadius="5px"
        px="16px"
        py={"8px"}
        onClick={() => setIsOpen(!isOpen)}
        cursor="pointer"
        border={`1px solid ${colors.brand.border}`}
        // color={filter.filterSliderProps.options.filter(option => option.checked).length ? "white" : ""}
        // bg={
        //   filter.filterSliderProps.options.filter(option => option.checked).length
        //     ? colors.brand.navy.dark
        //     : isOpen
        //     ? colors.brand.beige.light
        //     : "white"
        // }
      >
        {filter?.filter?.name}
        <Box transform={isOpen ? "rotateX(180deg)" : "rotateX(0deg)"}>
          <Icon
            // color={filter.filterSliderProps.options.filter(option => option.checked).length ? "white" : "black"}
            ml="10px"
            name="chevronDown"
            size="14px"
          ></Icon>
        </Box>
      </Flex>
      {isOpen && (
        <Flex
          zIndex={6}
          bg={"white"}
          px={2}
          pt={3}
          pb={4}
          border={`1px solid ${colors.brand.border}`}
          borderRadius="5px"
          flexDirection={"column"}
          position="absolute"
          top={"100%"}
          left={0}
          maxHeight={"400px"}
          overflow={"auto"}
          width={`250px`}
        >
          <Box>
            <Flex justify="space-between" mb={2}>
              <Box>${localValue[0]}</Box>
              <Box>${localValue[1]}</Box>
            </Flex>
            <ReactSlider
              min={0}
              max={280}
              step={10}
              {...filter?.filterSliderProps?.reactSliderProps}
              value={localValue}
              className="rs-price-slider"
              ariaLabel={["Lower thumb", "Upper thumb"]}
              ariaValuetext={state => `$${state.valueNow}`}
              renderThumb={props => <div {...props} />}
              onChange={(value: [number, number]) => {
                setLocalValue(value);
              }}
              onAfterChange={(value: [number, number]) => {
                filter?.filterSliderProps?.handleChange(value);
              }}
            />
          </Box>
        </Flex>
      )}
    </Flex>
  )
}

export default FilterSlider
